// eslint-disable-next-line no-restricted-imports
import {
  QueryInput_OperationController_GetClients_ClientType,
  useOperationGetClientsQuery,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { ListData, ListDataQueryFunction } from 'api/types/data';
import { OperationClientsData } from 'api/types/data/operation';
import { PrimaryClientType } from 'api/types/entity';
import { lodash } from 'helpers';

export const useOperationClients: ListDataQueryFunction<
  OperationClientsData,
  {
    search?: string;
  },
  '',
  { clientType: PrimaryClientType }
> = ({ pagination, filter, params }) => {
  const {
    loading,
    error: serverError,
    data,
  } = useOperationGetClientsQuery({
    variables: {
      limit: pagination.limit,
      clientType:
        QueryInput_OperationController_GetClients_ClientType[
          params!.clientType
        ],
      page: pagination.page + 1,
      search: filter?.search?.toString() || undefined,
    },
  });

  const error = useError(serverError);

  const listData: ListData<OperationClientsData> | undefined = data?.clients
    ? {
        total: data?.clients.total,
        list: lodash.compact(data?.clients.list).map((record) => ({
          id: record.id,
          name: record.name,
          personalAccountNumber: record.personalAccountNumber,
        })),
      }
    : undefined;

  return {
    listData,
    loading,
    error,
  };
};
